import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      const hash = window.location.hash;
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) { navigate("/login"); return; }
      const session_id = m[1];
      try {
        const { data } = await api.post("/auth/session", { session_id });
        if (data.token) localStorage.setItem("pg_token", data.token);
        setUser(data.user);
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { state: { user: data.user }, replace: true });
      } catch (e) {
        setError("Authentication failed. Redirecting…");
        setTimeout(() => navigate("/login"), 1500);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center text-sm font-mono-pg" data-testid="auth-callback">
      {error || "Signing you in securely…"}
    </div>
  );
}
